import { Allergen, VariantDietaryInformation } from '../generated/types/api';

export enum miseToNibllHomeAllergens {
  gluten = 'WHEAT',
  dairy = 'MILK',
  soy = 'SOYBEAN',
  eggs = 'EGGS',
  fish = 'FISH',
  tree_nuts = 'TREE_NUTS',
  shellfish = 'SHELLFISH',
  peanuts = 'PEANUTS',
  nuts = 'PEANUTS',
  'tree nuts' = 'TREE_NUTS'
}

export enum DietType {
  NonSpicy = 'NON_SPICY',
  Pescatarian = 'PESCATARIAN',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
  NoRedMeat = 'NO_RED_MEAT',
  DairyFree = 'DAIRY_FREE',
  GlutenFree = 'GLUTEN_FREE',
  LowCarb = 'LOW_CARB',
  Flexitarian = 'FLEXITARIAN'
}

/**
 * Returns whether the dish contains any of the user's allergens.
 *
 * @param dishAllergens MiseAllergens The allergen data for the dish served by the Mise API.
 * @param allergens Allergen The user's allergen preferences.
 * @returns boolean
 */
export const dishContainsAllergens = (
  dietary_information: VariantDietaryInformation,
  allergens: Allergen[]
): boolean => {
  return allergens.some(allergen => dietary_information.allergens.includes(allergen));
};

export const selectAllergenAlert = (variantAllergens: Allergen[], userAllergens: Allergen[]) => {
  const containedAllergens = variantAllergens
    .filter(allergen => userAllergens.includes(allergen))
    .map((allergen: string) => allergen.replace('_', ' ').toLowerCase());

  if (containedAllergens.length === 1) return `Contains ${containedAllergens[0]}`;
  if (containedAllergens.length > 1) {
    const finalAllergen = containedAllergens.pop();

    return `Contains ${containedAllergens.join(', ')} & ${finalAllergen}`;
  }
};
